<template>
  <footer class="footer">
    <div class="locale">
      <LocaleSeletor />
    </div>
    <div class="info">
      <div v-if="!isCN" class="social">
        <a href="https://facebook.com/muzikcom/" target="_blank" rel="noopener noreferrer"
           aria-label="Facebook" title="link facebook" class="link"
        >
          <img v-if="!overIcon.fb" v-img-lazy-loader
               :data-src="'/img/social/footer/ic-fb.png'" :data-hide="false"
               width="30" height="30" title="FB" alt="FB"
               @mouseover="overIcon.fb = true"
          >
          <img v-else src="/img/social/footer/ic-fb-hover.png" width="30" height="30" title="FB" alt="FB"
               @mouseleave="overIcon.fb = false" @click="overIcon.fb = false"
          >
        </a>
        <a href="https://www.instagram.com/muzikmagazine/" target="_blank" rel="noopener noreferrer"
           aria-label="Instagram" title="link instagram" class="link"
        >
          <img v-if="!overIcon.ig" v-img-lazy-loader
               :data-src="'/img/social/footer/ic-ig.png'" :data-hide="false"
               width="30" height="30" title="IG" alt="IG"
               @mouseover="overIcon.ig = true"
          >
          <img v-else src="/img/social/footer/ic-ig-hover.png" width="30" height="30" title="IG" alt="IG"
               @mouseleave="overIcon.ig = false" @click="overIcon.ig = false"
          >
        </a>
        <a href="http://line.me/ti/p/@pwr7122w#~" target="_blank" rel="noopener noreferrer"
           aria-label="Line" title="link line" class="link"
        >
          <img v-if="!overIcon.line" v-img-lazy-loader
               :data-src="'/img/social/footer/ic-line.png'" :data-hide="false"
               width="30" height="30" title="LINE" alt="LINE"
               @mouseover="overIcon.line = true"
          >
          <img v-else src="/img/social/footer/ic-line-hover.png" width="30" height="30" title="LINE" alt="LINE"
               @mouseleave="overIcon.line = false" @click="overIcon.line = false"
          >
        </a>
        <a href="https://www.youtube.com/user/MUZIKmagazine" target="_blank" rel="noopener noreferrer"
           aria-label="Youtube" title="link youtube" class="link"
        >
          <img v-if="!overIcon.youtube" v-img-lazy-loader
               :data-src="'/img/social/footer/ic-youtube.png'" :data-hide="false"
               width="30" height="30" title="YT" alt="YT"
               @mouseover="overIcon.youtube = true"
          >
          <img v-else src="/img/social/footer/ic-youtube-hover.png" width="30" height="30" title="YT" alt="YT"
               @mouseleave="overIcon.youtube = false" @click="overIcon.youtube = false"
          >
        </a>
      </div>
      <div v-else class="social">
        <!-- <a href="" target="_blank" rel="noopener noreferrer"
           aria-label="Wechat" title="link wechat" class="link"
        >
          <img v-if="!overIcon.wechat" v-img-lazy-loader
               :data-src="'/img/social/footer/ic-wechat.png'" :data-hide="false"
               width="30" height="30" title="WC" alt="WC"
               @mouseover="overIcon.wechat = true"
          >
          <img v-else src="/img/social/footer/ic-wechat-hover.png" width="30" height="30" title="WC" alt="WC"
               @mouseleave="overIcon.wechat = false" @click="overIcon.wechat = false"
          >
        </a> -->
      </div>
      <div class="website">
        <span v-if="!isCN" class="company">
          © 2019 MUZIK Creative Digital Ltd.
        </span>
        <span v-else>
          © 2019 Beijing Ximan Culture Communication Co., Ltd.
        </span>
        <span class="verison">
          {{ version }}
        </span>
      </div>
      <div class="links">
        <!-- <a class="link" href="">{{ $t('TERMS.TITLE') }}</a> -->
        <RouterLink :to="{ name: 'terms', params: {locale: $i18n.localePath()}}" :title="$t('TERMS.TITLE')" class="link" aria-label="terms">
          {{ $t('TERMS.TITLE') }}
        </RouterLink>
        <RouterLink :to="{ name: 'privacy', params: {locale: $i18n.localePath()}}" :title="$t('PRIVACY.TITLE')" class="link" aria-label="privacy">
          {{ $t('PRIVACY.TITLE') }}
        </RouterLink>
        <RouterLink :to="{ name: 'about', params: {locale: $i18n.localePath()}}" :title="$t('ABOUT.TITLE')" class="link" aria-label="about">
          {{ $t('ABOUT.TITLE') }}
        </RouterLink>
        <a :title="$t('COOPERATION.TITLE')" href="https://muk.page.link/rbGQ" target="_blank"
           rel="noopener noreferrer" class="link" aria-label="cooperation"
        >
          {{ $t('COOPERATION.TITLE') }}
        </a>
        <!-- <router-link :to="{ name: 'cooperation', params: {locale: $i18n.localePath()}}" class="link">{{ $t('COOPERATION.TITLE') }}</router-link> -->
        <!-- <a class="link" href="">{{ $t('FOOTER.ALL_TRACKS') }}</a> -->
        <!-- <a class="link" href="">{{ $t('FOOTER.ALL_PLAYLISTS') }}</a> -->
        <!-- <a class="link" href="">{{ $t('FOOTER.COMPOSER_LIST') }}</a> -->
        <!-- <a class="link" href="">{{ $t('FOOTER.PERFORMER_LIST') }}</a> -->
        <!-- <router-link
          :to="{ name: 'mediaKit', params: { locale: $i18n.localePath() }}"
          :title="$t('MEDIA_KIT.TITLE')"
          class="link" aria-label="mediaKit">{{ $t('MEDIA_KIT.TITLE') }}
        </router-link> -->
      </div>
      <div v-if="isCN" class="links">
        <a :title="$t('CN_CERTIFICATE.ICP_CERTIFICATE')" href="http://beian.miit.gov.cn" target="_blank"
           rel="noopener noreferrer" class="link" aria-label="icp-certificate"
        >
          {{ $t('CN_CERTIFICATE.ICP_CERTIFICATE') }}
        </a>
        <a :title="$t('CN_CERTIFICATE.ICP_FILING')" href="http://beian.miit.gov.cn" target="_blank"
           rel="noopener noreferrer" class="link" aria-label="icp-filing"
        >
          {{ $t('CN_CERTIFICATE.ICP_FILING') }}
        </a>
        <a :title="$t('CN_CERTIFICATE.BUSINESS_LICENSE')" href="/img/cn/muzikstudy.net.jpg" target="_blank"
           rel="noopener noreferrer" class="link" aria-label="license"
        >
          {{ $t('CN_CERTIFICATE.BUSINESS_LICENSE') }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import ImgLazyLoader from '@/directives/ImgLazyLoader'
import LocaleSeletor from '@/components/common/LocaleSeletor'
export default {
  name: 'MuzikFooter',
  components: {
    LocaleSeletor
  },
  directives: {
    ImgLazyLoader
  },
  data() {
    return {
      isCN: this.$isCN,
      overIcon: {
        fb: false,
        ig: false,
        line: false,
        youtube: false,
        wechat: false
      }
    }
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.footer {
  display: block; // write in query media
  width: 100%; // write in query media
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 $padding-lg-x1;
  padding-top: 36px;      // update in query media
  padding-bottom: 72px;      // update in query media
  border-top: solid 1px $grey-ec;
  text-align: left;
  // background-color: #ffb6c1; // for testing
  // border: solid 1px #ffb6c1; // for testing
  .social {
    margin-bottom: 24px;
    .link {
      display: inline-block;
      width: 30px;
      height: 30px;
      margin-right: 30px;
      transition: color .4s ease;
      cursor: pointer;
      overflow: hidden;
      img {
        opacity: 0; // init state, trigger diaply in img lazy loader
        color: transparent;
      }
    }
  }
  .info {
    display: inline-block;
    width: 50%;
    vertical-align: middle;
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;

    .website {
      margin-bottom: 4px;
      line-height: 1.6;
      text-align: left;
    }
    .company {
      color: $grey-7d;
    }
    .verison {
      color: #ffffff;
    }
    .links {
      // min-height: 36px;
      margin-bottom: 24px;
      .link {
        display: inline-block;
        vertical-align: top;
        height: 20px;
        line-height: 20px;
        text-decoration: none;
        color: $grey-9b;
        cursor: pointer;
        transition: color .4s ease;
        &::after {
          content: '|';
          padding: 5px;
        }
        &:last-child::after {
          content: '';
          display: none;
        }
        @media (hover: hover) {
          &:hover {
            color: $link-hover;
            &::after {
              color: $grey-9b;
            }
          }
          &:active {
            color: $link-hover;
          }
        }
      }
    }
  }
  .locale {
    float: right;
    width: 50%;
    text-align: right;
    vertical-align: middle;
    // border: solid 1px blueviolet; // for testing
  }
}

@media only screen and (max-width: 1439.98px) {
  .footer {
  }
}
@media only screen and (max-width: 1023.98px) {
  .footer {
    .info {
      display: block;
      width: 100%;
    }
    .locale {
      display: block;
      width: 100%;
      text-align: left;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  // (min-width: 320px) and (max-width: 767.98px)
  .footer {
    display: block;
    padding-top: 24px;
    padding-bottom: 89px; // 65 + 24
    padding-left:  $padding-xs-x1;
    padding-right:  $padding-xs-x1;
    .info {
      display: block;
      width: 100%;
      font-size: 12px;
    }
    .locale {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
